import axios from "axios"
import NProgress from "nprogress"
import { Message } from "element-ui"
import Vue from "vue"
const serverConfigs = require("../../config/config")

// axios默认配置
axios.defaults.timeout = 30000;
axios.defaults.baseURL = serverConfigs().baseURL
axios.withCredentials = true
// axios.defaults.baseURL = "/api"

// http request 拦截器
axios.interceptors.request.use(config => {

  NProgress.start()
  let nonTokenAccessURL = ["login","secondConfirm","startResetPassword","emailConfirmed","checkResetToken","updatePassword"
    ,"refereeLogin","screenMemberLogin","externalLogin","externalStartResetPassword"]
  let nonTokenAccessFullURL = ["/checklist/fetch", "/api/cas/loginChecklist"]
  console.log(Vue.prototype.$cookies)
      console.log(document.cookie)
  console.log("request token root "+Vue.prototype.$cookies.get("access_token"))
  console.log(config)
  console.log("vue token "+Vue.prototype.$serverAccessToken)
  config.headers["Content-Type"] = "application/json;charset=UTF-8"
  if (Vue.prototype.$cookies.get("access_token")) {
    if(config.headers.Authorization){
      return config
    }
    else{
      if(Vue.prototype.$serverAccessToken != ""){
        if(Vue.prototype.$cookies.get("access_token") !==  Vue.prototype.$serverAccessToken){
          return Promise.reject("duplicate users login at the same time, logging out")
        }
      }
      else{
        // some of non Token URL should not set token since the request not using current token
        if(!nonTokenAccessURL.includes(config.url.split('/').pop()) && !nonTokenAccessFullURL.includes(config.url)){
          Vue.prototype.$serverAccessToken = Vue.prototype.$cookies.get("access_token")
        }
      }
      config.headers.Authorization = "Bearer " + Vue.prototype.$cookies.get("access_token")
    }
  }
  else{
    if(config.headers.Authorization){
      return config
    }
    else{
      if(!nonTokenAccessURL.includes(config.url.split('/').pop()) && !nonTokenAccessFullURL.includes(config.url)){
        return Promise.reject("Unauthorized login, logging out")
      }
    }
  }
  return config
},
error => {
  return Promise.reject(error.response)
})

axios.interceptors.response.use(response => {
  NProgress.done()
  if (response.data.code === 11000) {
    Vue.prototype.$cookies.set("access_token", response.data.message.access_token, 60 * 60 * 4)
    Vue.prototype.$cookies.set("user_name", response.data.message.user_name, 60 * 60 * 4)
    Vue.prototype.$serverAccessToken = response.data.message.access_token
    return Promise.resolve()
  } else if (response.data.code === 10000) {
    console.log("code 100000")
    //User Access Denied message leads to confusion
    if(response.data.message != "User Access Denied"){
      Message({
        message: response.data.message,
        type: "warning"
      })
    }
    return Promise.reject(response)
  } else {
    return Promise.resolve(response)
  }
},
error => {
  console.log(error)
    if(!error.response){
      console.log(error)
        let errorResponse = {
        "data":{}
        }
        errorResponse.data.message = error
        return Promise.reject(errorResponse)
    }
  if (error.response.status === 404) {
    // Message({
    //   message: "Request URL Error",
    //   type: "warning"
    // })
  } else if (error.response.status === 401) {
    // Message({
    //   message: error.response.data.message,
    //   type: "warning"
    // })
    // Cookies.remove("access_token")
    // console.log("User Logged out!")
    // // this.$store.dispatch('logOut');
    // setTimeout(() => {
    //   location.reload()
    // }, 1000)
  } else if (error.response.status === 500) {
    // Message({
    //   message: "Service Error, please contact manager-code: 500",
    //   type: "error"
    // })
  } else if (error.response.status === 504) {
    // Message({
    //   message: "Timeout, please contact manager",
    //   type: "error"
    // })
  }else if (error.response.status === 413) {
    // Message({
    //   message: "File is too large",
    //   type: "error"
    // })
  } else {
    // Message({
    //   message: "Unknown Failure, please contact manager",
    //   type: "error"
    // })
  }
  return Promise.reject(error.response) // 返回接口返回的错误信息
})
export default axios;
